import { useState } from "react";
import { Link } from "react-router-dom";

export const CookieBanner = () => {
  const [show, setShow] = useState(() => !localStorage.getItem("nasdeal_cookies_ack"));
  if (!show) return null;
  const ack = () => { localStorage.setItem("nasdeal_cookies_ack", "1"); setShow(false); };
  return (
    <div className="fixed bottom-0 inset-x-0 z-[60] p-4 sm:p-6" data-testid="cookie-banner">
      <div className="max-w-3xl mx-auto bg-[#141414]/95 backdrop-blur-xl border border-[#C9A45C]/30 p-5 flex flex-col sm:flex-row gap-4 sm:items-center">
        <p className="text-xs sm:text-sm text-[#F8F6F1]/75 flex-1">
          Ce site utilise uniquement des cookies et un stockage local strictement nécessaires (panier, session administrateur).
          Aucun cookie publicitaire. <Link to="/cookies" className="text-[#C9A45C] underline underline-offset-4">En savoir plus</Link>
        </p>
        <button onClick={ack} className="btn-gold !py-3 !px-6" data-testid="cookie-accept-button">J'ai compris</button>
      </div>
    </div>
  );
};
